module.exports = __webpack_public_path__ + "img/9d3e0c109040ac9676ba7afeb1c9b073.png";